import { dashboardConstants } from "../constants";
import { dashboardService } from "../services";
//import { loaderMaskActions } from './';
import { handleErrors } from "../../utils";

export const dashboardActions = {
  getLayout,
  getWedgetData
};

function getLayout(params, oldDashboard) {
  return dispatch => {
    //dispatch(loaderMaskActions.show('Loading reports...'));
    dispatch(request());
    dashboardService.getLayout(params).then(
      data => {
        var promises = [];
        if (
          data.Data.dashboard.rows.length &&
          data.Data.dashboard.rows.length <= 8
        ) {
          data.Data.dashboard.rows.forEach((row, index) => {
            row.forEach((widget, indx) => {
              if (widget.WidgetType === "pie" || widget.WidgetType === "line") {
                var _getDataParams = { ...params, WidgetId: widget.WidgetId };
                if (
                  oldDashboard &&
                  oldDashboard.widgets &&
                  oldDashboard.widgets.rows &&
                  oldDashboard.widgets.rows.length &&
                  oldDashboard.widgets.rows[index] &&
                  oldDashboard.widgets.rows[index][indx] &&
                  oldDashboard.widgets.rows[index][indx].granularity
                ) {
                  widget["granularity"] = _getDataParams["Granularity"] =
                    oldDashboard.widgets.rows[index][indx].granularity;
                }
                widget["loading"] = true;
                dispatch(success(data.Data.dashboard));
                promises.push(
                  dashboardService.getWedgetData(_getDataParams).then(
                    wData => {
                      widget["data"] = wData.Data;
                      widget["loading"] = false;
                      dispatch(success(data.Data.dashboard));
                    },
                    error => {
                      widget["data"] = null;
                      widget["loading"] = false;
                      handleErrors(error, dispatch);
                      dispatch(failure(error));
                    }
                  )
                );
              }
            });
          });
          Promise.all(promises).then(
            () => {
              dispatch(success(data.Data.dashboard));
            },
            error => {
              handleErrors(error, dispatch);
              //dispatch(loaderMaskActions.hide(''));
              dispatch(failure(error));
            }
          );
        }
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: dashboardConstants.GETALL_REQUEST };
  }
  function success(dashboard) {
    return { type: dashboardConstants.GET_LAYOUT_SUCCESS, dashboard };
  }
  function failure(error) {
    return { type: dashboardConstants.GETALL_FAILURE, error };
  }
}

function getWedgetData(params) {
  return dispatch => {
    //dispatch(loaderMaskActions.show('Loading reports...'));
    dispatch(request(params.WidgetId, params.Granularity));
    dashboardService.getWedgetData(params).then(
      data => {
        dispatch(success(data.Data, params.WidgetId));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request(widgetId, granularity) {
    return {
      type: dashboardConstants.GET_WIDGET_DATA_REQUEST,
      widgetId,
      granularity
    };
  }
  function success(data, widgetId) {
    return { type: dashboardConstants.GET_WIDGET_DATA_SUCCESS, data, widgetId };
  }
  function failure(error) {
    return { type: dashboardConstants.GETALL_FAILURE, error };
  }
}
